import { Tag, Typography } from "antd";
import React from "react";
import { toRGB } from "../../utils/colorUtils";
const { Text } = Typography;

const ColoredTag = ({
  name,
  color,
  fontSize = 12,
  shadow = true,
  border = false,
  width = 200,
  wrap = false,
    borderRadius=0,
    gradient=false,
    rounded=false
}) => {
    const commonStyle = {
        width,
        fontSize,
        border: border ? "1px solid #ededed" : "none",
        borderRadius
    }
    const className = shadow ? "shadow-sm" : "";
    const cornerRadius = rounded ? '25px' : '2px';

    const SpanNode = ()=> (
        <span
            style={{
                paddingLeft: "5px",
                textTransform: "capitalize",
                whiteSpace: wrap ? "nowrap" : ""
            }}
        >
        <Text ellipsis={{rows: 1}} style={{fontSize}}>
          {name}
        </Text>
      </span>
    )
    if (gradient === true) {
        return (
            <Tag
                style={{
                    background: `linear-gradient(to right, ${color}, ${toRGB(
                        color,
                        0.7
                    )} 4px, ${toRGB(color, 1)} 8px, transparent 8px)`,
                    ...commonStyle
                }}
                className={className}
            >
                <SpanNode />
            </Tag>
        );
    }
    return (
        <Tag style={{
                    background: `linear-gradient(to right, ${color}, ${color} 6px, transparent 6px)`,
                    ...commonStyle,
                    borderTopLeftRadius: cornerRadius,
                    borderBottomLeftRadius: cornerRadius,
                }}
                className={className}
        >
            <SpanNode />
        </Tag>
    )
};

export default ColoredTag;
